import Timeline from '@mui/lab/Timeline';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { styled } from '@mui/material/styles';

export const StyledTimeline = styled(Timeline)(() => ({
  alignItems: 'flex-start',
  padding: 4,
  marginTop: 8,
  marginBottom: 0
}));

export const StyledTimelineItem = styled(TimelineItem)(() => ({
  '&:before': { paddingLeft: 0, paddingRight: 0 }
}));

export const StyledTimelineSeparator = styled(TimelineSeparator)(() => ({
  opacity: 0.75
}));

export const StyledTimelineContent = styled(TimelineContent)(({ theme }) => ({
  paddingTop: 5,
  height: 72,
  '& p': { whiteSpace: 'nowrap' },
  '& p:first-of-type': { fontWeight: 600 },
  '& p:nth-of-type(2)': {
    fontSize: '0.75rem'
  },
  '& p:nth-of-type(3)': {
    color: theme.palette.primary.light,
    fontSize: '0.75rem'
  }
}));
